import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const labelNames = {
  laMigrateBalanceDelete: ItemName.of([Locale.ja, 'リース残高移行削除']),
};
const laMigrateBalanceDelete = { labelNames };

export { laMigrateBalanceDelete };
